export enum DocumentEvents {
  CreateDocumentButtonClicked = 'document.CreateButtonClicked',
  PlusDocumentButtonClicked = 'document.PlusButtonClicked',
  DocumentCreated = 'document.Created',
  TeamspaceCreated = 'document.CreatedTeamspace',
  DocumentEdited = 'document.Edited',
  DocumentOpened = 'document.Opened'
}
